import React, { useEffect, useState, useRef, createContext, useContext } from "react"

import Helmet from "react-helmet"

import { Link } from "gatsby"

import slug from "slug"

import { Button } from "./Button"
import useScrollPosition from "../hooks/useScrollPosition"

// import SafeAreaWrapper from "./SafeAreaWrapper"
import Container from "./Container"

import Solutions from "./Solutions"

import Logo from "./Icon/Logo"
import ArrowHeadFatDown from "./Icon/ArrowheadFatDown"

import MainDivRefContext from "../context/MainDivContext"

// const mainMenuItems = ["New features", "Blog", "Customers", "Contact"]
const mainMenuItems = ["Blog", "Support"]

const MenuItem = ({ to, partiallyActive = false, children, className, activeClassName }) => (
	<Link
		to={to}
		role="menuitem"
		partiallyActive={partiallyActive}
		activeClassName={activeClassName || ""}
		className={className || ""}>
		{children}
	</Link>
)

const Navigation = ({
	translucent = false,
	showLogo = true,
	showItems = true,
	showDemo = true,
}) => {
	// const [translucent, setTranslucent] = useState(true)

	const [showSolutions, setShowSolutions] = useState(false)
	const [showMobileNavigation, setShowMobileNavigation] = useState(false)

	const [isFixed, setIsFixed] = useState(false)
	const mainDivRef = useContext(MainDivRefContext)

	const scrollPosition = useScrollPosition()
	const translucentNavigation =
		translucent && !(showSolutions || showMobileNavigation) && !isFixed

	useEffect(() => {
		const handleScroll = () => {
			const mainDiv = mainDivRef.current
			if (mainDiv) {
				const mainRect = mainDiv.getBoundingClientRect()

				if (mainRect.top < 0 && !isFixed) {
					setIsFixed(true)
				} else if (mainRect.top >= 0 && isFixed) {
					setIsFixed(false)
				}
			}
		}

		window.addEventListener("scroll", handleScroll)
		return () => {
			window.removeEventListener("scroll", handleScroll)
		}
	}, [isFixed, mainDivRef])

	return (
		<>
			<Helmet htmlAttributes={{ class: "scroll-pt-[100px] md:scroll-pt-[120px]" }} />

			<header
				id="navigation"
				className={`top-0 left-0 right-0 z-50
				${isFixed ? "fixed" : "absolute"}
				${translucentNavigation ? "bg-opacity-0" : "shadow-md glassmorphic-filter"}`}>
				<div
					className={`transition-all duration-300 ease-in-out flex flex-col
						${showSolutions || showMobileNavigation ? "h-screen overflow-y-scroll" : ""}
					`}>
					<Container>
						<nav className="flex-none flex flex-col w-full">
							<div
								className={`flex flex-nowrap flex-row items-center justify-start h-[60px] md:h-[80px] select-none`}>
								<div className="flex flex-none items-center flex-grow-0 flex-shrink-0">
									{showLogo && (
										<Link to="/">
											<Logo
												alt="Cloud Fleet Manager Logo"
												title="Cloud Fleet Manager"
												className={`box-content ${
													translucentNavigation
														? "text-white"
														: "text-tealblue"
												}`}
											/>
										</Link>
									)}
								</div>

								<ul className="h-full items-center justify-end flex-grow flex flex-row flex-nowrap">
									{showItems && (
										<>
											<li role="none" className="hidden xl:inline">
												<span
													onClick={() => setShowSolutions(prev => !prev)}
													onKeyDown={() =>
														setShowSolutions(prev => !prev)
													}
													role="menuitem"
													tabIndex="0"
													className={`cursor-pointer flex items-center font-medium whitespace-nowrap ${
														translucentNavigation
															? "text-white"
															: "text-nevada "
													}`}>
													Solutions
													<span className={`ml-4 mr-20`}>
														<ArrowHeadFatDown
															className={`fill-current transform transition-transform duration-250 ${
																showSolutions
																	? "rotate-180"
																	: "rotate-0"
															}`}
														/>
													</span>
												</span>
											</li>
											{mainMenuItems.map(item => (
												<li
													key={`mainmenu-${slug(item)}`}
													role="none"
													className={`mx-20 last:mr-40 hidden xl:inline ${
														translucentNavigation
															? "text-white "
															: "text-nevada  "
													}`}>
													<MenuItem
														to={`/${slug(item)}`}
														partiallyActive={true}
														className={`flex items-center whitespace-nowrap font-medium decoration-2 underline-offset-[5px] ${
															translucentNavigation
																? "hover:decoration-white hover:underline"
																: "hover:decoration-nevada hover:underline"
														}`}
														activeClassName={`${
															translucentNavigation
																? "text-white decoration-b-white underline"
																: "text-tealblue decoration-tealblue decoration-2 underline"
														}`}>
														{item}
													</MenuItem>
												</li>
											))}
										</>
									)}
								</ul>

								<ul className="flex-none flex">
									{showDemo && (
										<>
											<li className="hidden lg:inline self-center">
												<Link to="/demo">
													<Button
														primary={true}
														label="Schedule a demo"
													/>
												</Link>
											</li>
											{/* <li className="hidden lg:inline self-center mx-12">
												<Link to="/support">
													<TextButton
														to="/support"
														light={translucentNavigation}>
														Get Support
													</TextButton>
												</Link>
											</li> */}
											<li className="ml-24 w-24 h-18 flex justify-center self-center fill-current xl:hidden">
												<span
													className={`cursor-pointer ${
														translucentNavigation
															? "text-white hover:text-white"
															: "text-nevada hover:text-pictonblue"
													}`}>
													{showSolutions || showMobileNavigation ? (
														<svg
															onClick={() => {
																setShowSolutions(false)
																setShowMobileNavigation(false)
															}}
															className="fill-current"
															width="18"
															height="18"
															xmlns="http://www.w3.org/2000/svg">
															<path d="M10.429 9L18 1.429 16.571 0 9 7.571 1.429 0 0 1.429 7.571 9 0 16.571 1.429 18 9 10.429 16.571 18 18 16.571z" />
														</svg>
													) : (
														<svg
															onClick={() =>
																setShowMobileNavigation(true)
															}
															className="fill-current"
															width="24"
															height="18"
															xmlns="http://www.w3.org/2000/svg">
															<path d="M0 0h24v2H0V0Zm0 16h24v2H0v-2Zm0-8h24v2H0V8Z" />
														</svg>
													)}
												</span>
											</li>
										</>
									)}
								</ul>
							</div>
						</nav>
					</Container>

					{(showSolutions || showMobileNavigation) && (
						<>
							<Helmet bodyAttributes={{ class: "overflow-hidden" }} />

							<div className="bg-porcelain grow flex flex-col">
								<Container className="grow">
									<ul className="flex flex-col">
										{showDemo && (
											<>
												<li className="pt-40 md:pt-60 inline lg:hidden ">
													<Link to="/demo">
														<Button
															primary={true}
															label="Schedule a demo"
															className="w-full text-center"
														/>
													</Link>
												</li>

												{/* <li className="pt-20 pb-40 md:pt-30 md:pb-60 inline lg:hidden border-iron border-b">
													<a
														href="https://hanseaticsoft.freshdesk.com/support/tickets/new"
														target="_blank"
														rel="noreferrer">
														<Button
															primary={true}
															label="Get Support"
															className="w-full"
														/>
													</a>
												</li> */}
											</>
										)}

										{showItems && showSolutions && (
											<Solutions
												handleBackButtonClick={() => {
													setShowSolutions(false)
													setShowMobileNavigation(true)
												}}
											/>
										)}
										{showItems && showMobileNavigation && (
											<MobileNavigation
												handleSolutionsClick={() => {
													setShowMobileNavigation(false)
													setShowSolutions(true)
												}}
											/>
										)}
									</ul>
								</Container>
								{/* {showSolutions && (
									<div className="col-span-12 bg-iron py-30 flex-none">
										<div className="flex flex-row items-center justify-center">
											<a
												href="/Cloud-Fleet-Manager-Product-Brochure.pdf"
												download
												data-umami-event="download-product-brochure">
												<span className="rounded-[6px] px-[7px] py-[7px] bg-pictonblue hover:bg-tealblue mr-8 flex-none">
													<Download className="w-16 h-18 text-white" />
												</span>
												<span>Download Product Brochure</span>
											</a>
										</div>
									</div>
								)} */}
							</div>
						</>
					)}
				</div>
			</header>

			{/* <div
				className={`w-full h-40 ${
					translucentNavigation ? "bg-atlantis" : "bg-solaris"
				}`}></div> */}
		</>
	)
}

const MobileNavigation = ({ handleSolutionsClick }) => (
	<>
		<li className="pt-40 pb-20">
			<button
				className="display2 hover:cursor-pointer text-jetblack hover:text-pictonblue text-left"
				onClick={handleSolutionsClick}>
				Solutions
			</button>
		</li>
		{mainMenuItems.map(item => (
			<li className="py-20">
				<MenuItem
					to={`/${slug(item)}`}
					partiallyActive={true}
					className="display2 text-jetblack whitespace-nowrap hover:text-pictonblue"
					activeClassName="text-tealblue">
					{item}
				</MenuItem>
			</li>
		))}

		{/* <li className="pb-60">
			<Grid withContainer={false}>
				<div className="col-span-12 md:col-span-6 border-iron border-t mt-20 pt-40">
					<h3 className="display3">Always up to date with our Newsletter.</h3>
					<p className="bodyp mt-12 mb-30">
						Join hundreds of fleet managers, inspectors and ship owners who read our
						news first.
					</p>

					<a
						href={process.env.GATSBY_NEWSLETTER_SUBSCRIPTION_URL}
						target="_blank"
						rel="noreferrer">
						<Button primary className="" label="Subscribe" />
					</a>
				</div>
			</Grid>
		</li> */}
	</>
)

export { Navigation }
